import React from 'react';
import loginStyles from '../../../stylesheets/components/login.module.scss';
import DocumentLink from '../components/legal_documents/DocumentLink';

const LoginFooter = () => {
  return (
    <div className={loginStyles.loginFooter}>
      <p className={loginStyles.loginLegalCopy}>
        By continuing, you agree to the{' '}
        <DocumentLink className={loginStyles.loginInlineLink} document="terms">
          Terms
        </DocumentLink>{' '}
        and{' '}
        <DocumentLink className={loginStyles.loginInlineLink} document="policy">
          Privacy Policy
        </DocumentLink>
        .
      </p>
    </div>
  );
};

export default LoginFooter;
